import { useState, useEffect } from 'react';

// Shared mobile-breakpoint hook. Tracks the standard max-width:768px media query
// so components can switch to a mobile layout (e.g. centered footer, full-width
// carousel cards) without duplicating matchMedia wiring.
export default function useIsMobile(query = '(max-width: 768px)') {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
